const usernameRegexp = /^[\u4e00-\u9fa5a-zA-Z0-9]{6,16}$/;
const usernameRegTip = '账号只能包含中英文，数字(6-16位)';

const nicknameRegexp = /^[\u4e00-\u9fa5a-zA-Z0-9_]{2,8}$/;
const nicknameRegTip = '昵称可以是中英文，数字，下划线(2-8位)';

const passwordRegexp = /^[a-zA-Z0-9]{6,16}$/;
const passwordRegTip = '密码只能包含字母和数字(6-16位)';
const nameRegexp = /^[\u4e00-\u9fa5]{2,4}$/;
const phoneRegexp = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
const phoneRegTip = '手机格式错误';
const teleRegexp = /^(0\d{2,3})-?(\d{7,8})$/;
const emailRegexp = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
const emailRegTip = '邮箱格式错误';
const idcardRegexp = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
const qqRegexp = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
const zipcodeRegexp = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;

const RegUtil = {
  phoneRegexp,
  phoneRegTip,
  teleRegexp,
  nameRegexp,
  usernameRegexp,
  usernameRegTip,
  nicknameRegexp,
  nicknameRegTip,
  passwordRegexp,
  passwordRegTip,
  emailRegexp,
  emailRegTip,
  idcardRegexp,
  qqRegexp,
  zipcodeRegexp,
  filenameRegex,
};

export default RegUtil;
